import React from "react";

export default function Settings() {
  return <div>애플리케이션 설정 페이지입니다.</div>;
}
